import {get, patch, post} from '@/services/infrastructure/api.service'
import {PendingTransaction, UpdatePendingTransactionCommand, RefreshStatusPendingTransactionCommand} from '@/pending-transaction/pendingTransaction.types'
import {Either} from '@/types/either/Either'
import {Problem} from '@/types/Problem'


const PENDING_TRANSACTIONS_PATH = '/pending-transactions'

const getPendingTransactions = async (): Promise<PendingTransaction[]> => await get(PENDING_TRANSACTIONS_PATH) ?? []

const updatePendingTransaction = async (cmd: UpdatePendingTransactionCommand): Promise<Either<Problem, PendingTransaction>> => await patch(PENDING_TRANSACTIONS_PATH, cmd)

const refreshPendingTransactionPaymentStatus = async (cmd: RefreshStatusPendingTransactionCommand) => await post(`${PENDING_TRANSACTIONS_PATH}/-/:refresh-payment-status`, cmd)

const getPendingPaymentCount = async (tenantId?: string) => await get(PENDING_TRANSACTIONS_PATH + '/count', {}, tenantId)

export {
    getPendingTransactions,
    updatePendingTransaction,
    getPendingPaymentCount,
    refreshPendingTransactionPaymentStatus
}
